import { ModuleFE_Resource } from './ModuleFE_Resource.js';
export const ModulePackFE_ResourceDB = [ModuleFE_Resource];
//# sourceMappingURL=module-pack.js.map